<template>
  <section
    :class="{
      'portable-wistia-video': true,
    }"
  >
    <Padding :padding>
      <WistiaVideo
        v-if="wistiaVideo"
        v-bind="wistiaVideo"
      />
    </Padding>
  </section>
</template>

<script lang="ts" setup>
import WistiaVideo from './WistiaVideo.vue';
import Padding from '~/components/Atmos/Padding/Padding.vue';
import type { PortableTextWistiaVideo } from '~/sanity/types';

const props = defineProps<PortableTextWistiaVideo>();
const maxWidth = ref(props.wistiaVideo?.width + (props.wistiaVideo?.widthType || 'px') || '80%');
const videoWidthState = useVideoWidth();
videoWidthState.setMaxWidth(maxWidth.value);
</script>

<style>
/*set max width of next div (work as video caption) to the max width of the video*/
.portable-wistia-video + div {
  max-width: var(--wistia-max-width);
  margin: 0 auto 2.5rem;
  font-size: 10pt;
}
</style>
